import { createSelector } from '@reduxjs/toolkit'

export const makeSelectorUserdata = () => createSelector(
  (state) => state.login,
  (slice) => {
    return slice.userData
  }
)

export const makeSelectorContactInfo = () => createSelector(
  (state) => state.login,
  (slice) => {
    const { userData } = slice
    return {
      email: userData.email,
      employee_id: userData.employee_id,
      name: userData.name,
      address: userData.address,
      postal_code: userData.postal_code,
      city: userData.city,
      homepage: userData.homepage,
      phone: userData.phone
    }
  }
)
